import {ActionsTitle, ModalSearchWrapper, ProjectsCount} from "./styles";
import {MobileFilterSort} from "../../pages/explore/styles";
import {SortIcon} from "../../icons";
import {BrgButton, ButtonVariant, FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {FC, ReactNode, useMemo} from "react";
import {ProjectsSearchBar} from "../../components/projectsSearchBar/projectsSearchBar";
import {SortingTypeIndex} from "../../constants/sortingType";
import { EmployActionsModalWrapper, SendEmployProjectButton, SendProjectsTitle, SubtitleText} from "./employStyles";
import { LayoutConst, useModal } from "core";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import MobileSearchBar from "shared/components/MobileSearchBar/MobileSearchBar";

export type SearchDataT = {
    id: string;
}

interface SendProjectsTitleProps {
    count: number;
    onMobileSortingClick: () => void;
    onSend?: () => void;
    onSortingChange: (s: SortingTypeIndex) => void;
    sorting: SortingTypeIndex;
    sendText?: string;
    titleText?: string;
    subtitleText?: string;
    isClosed?: boolean;
    hideFilter?: boolean;
    hideCount?: boolean;
    hideSendButton?: boolean;
    noProjectVisible?: boolean;
    isDisabledSendButton?: boolean;
    isCompetitionModal?: boolean;
    showMobileClose?: boolean;
    searchData?: SearchDataT;
    chooseAllBox?: ReactNode;
    noProjectCheckbox?: ReactNode;
    tabs?: ReactNode;
    sortingMethods?: SortingTypeIndex[];
    checkbox?: boolean;
    hide?: boolean;
    fullTitle?: boolean;
    hideMainTitle?: boolean;
    children?: ReactNode;
}

export const SendProjectsEntity: FC<SendProjectsTitleProps> = ({
    count, 
    hideFilter, 
    hideCount, 
    hideSendButton = false, 
    noProjectVisible,
    chooseAllBox, 
    onMobileSortingClick, 
    sorting, 
    onSortingChange, 
    onSend, 
    isClosed, 
    children,
    tabs,
    hide = false,
    showMobileClose,
    searchData = undefined, 
    isDisabledSendButton,
    isCompetitionModal, 
    noProjectCheckbox,
    sortingMethods = undefined,
    sendText,
    titleText,
    subtitleText,
    hideMainTitle = false,
}) => {

    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const showSearch = useMemo(() => (searchData?.id), [searchData])

    const searchBar = useMemo(
        () => (
            <ProjectsSearchBar
                isLoading={false}
                sorting={sorting}
                hideRightBar={false}
                hideLeftBar={true}
                hideRightButtons
                onSortingChange={onSortingChange}
                isTagPage={false}
                projectCount={count}
                {...(!!sortingMethods ? {sortingMethods: sortingMethods} : undefined)}
            />
        ),
        [
            sorting,
            onSortingChange,
            sortingMethods,
            count
        ],
    );

    const searchInput = useMemo(() => (
        <ModalSearchWrapper>
            <MobileSearchBar placeholder={t('enter_name_or_title')} competitionId={searchData?.id} />
        </ModalSearchWrapper>
    ), [t, searchData])

    if (hide) {
        return null;
    }

    const headerCheckbox = noProjectVisible && !isClosed && noProjectCheckbox;
    const hasHeaderLeft =
        !hideMainTitle || !!subtitleText || !!headerCheckbox;
    const showActionsTitle =
        !!isClosed || hasHeaderLeft || !hideSendButton;

    return <EmployActionsModalWrapper direction="column" gy={24} zeroHeight={isClosed} fullWidth>
                {showActionsTitle && (
                <ActionsTitle 
                    justify='space-between' 
                    justifyMobile='space-between' 
                    direction='row' 
                    directionMobile="row"
                    style={{ 
                        marginBottom: (isS && noProjectCheckbox) ? 24 : 0,
                        visibility: isClosed ? 'hidden' : 'visible',
                    }} 
                >
                    <FlexBox direction="column" directionMobile="column" alignMobile="start" gy={subtitleText ? 8 : 0} style={{ gap: 8 }}>
                        {!hideMainTitle && (
                        <SendProjectsTitle mainTitle>
                            {titleText || t('competition.select_project')}
                        </SendProjectsTitle>
                        )}
                        {subtitleText && (
                            <SubtitleText>{subtitleText}</SubtitleText>
                        )}
                        {headerCheckbox} 
                    </FlexBox>
                    {!hideSendButton && (
                        <FlexBox 
                            alignMobile="flex-end" 
                            // gyMobile={showMobileClose && isMobile ? 16 : 0} 
                            direction="column"
                            widthMobile={'100%'} 
                            directionMobile="column"
                        >
                            <BrgButton 
                                variant={ButtonVariant.Filled} 
                                // width={187} 
                                fullWidth
                                disabled={isDisabledSendButton || hide} 
                                onClick={onSend}
                            >
                                {sendText || t('competition.send')}
                            </BrgButton>
                        </FlexBox>
                    )}
                </ActionsTitle>
                )}
                <FlexBox direction='row' justify='space-between' align='center'>
                {!hideCount && !tabs &&
                    <ProjectsCount>
                        {t('competition.selected_projects', {count: count})}
                    </ProjectsCount>
                }
                {!!tabs && (
                    <FlexBox direction='row' align='center' style={{ gap: 16 }}>
                        {tabs}
                    </FlexBox>
                )}
                {!hideFilter && (isMobile ? (
                    <MobileFilterSort onClick={onMobileSortingClick}>
                        <SortIcon/>
                        {t(`sorting_type.${sorting == 1 ? 'latest' : 'popular'}`)}
                    </MobileFilterSort>
                ) : searchBar)}
            </FlexBox>
            {chooseAllBox && chooseAllBox}
            {showSearch && searchInput}
        {children}
    </EmployActionsModalWrapper>
}import {ActionsTitle, ModalSearchWrapper, ProjectsCount} from "./styles";
import {MobileFilterSort} from "../../pages/explore/styles";
import {SortIcon} from "../../icons";
import {BrgButton, ButtonVariant, FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {FC, ReactNode, useMemo} from "react";
import {ProjectsSearchBar} from "../../components/projectsSearchBar/projectsSearchBar";
import {SortingTypeIndex} from "../../constants/sortingType";
import { EmployActionsModalWrapper, SendEmployProjectButton, SendProjectsTitle, SubtitleText} from "./employStyles";
import { LayoutConst, useModal } from "core";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import MobileSearchBar from "shared/components/MobileSearchBar/MobileSearchBar";

export type SearchDataT = {
    id: string;
}

interface SendProjectsTitleProps {
    count: number;
    onMobileSortingClick: () => void;
    onSend?: () => void;
    onSortingChange: (s: SortingTypeIndex) => void;
    sorting: SortingTypeIndex;
    sendText?: string;
    titleText?: string;
    subtitleText?: string;
    isClosed?: boolean;
    hideFilter?: boolean;
    hideCount?: boolean;
    hideSendButton?: boolean;
    noProjectVisible?: boolean;
    isDisabledSendButton?: boolean;
    isCompetitionModal?: boolean;
    showMobileClose?: boolean;
    searchData?: SearchDataT;
    chooseAllBox?: ReactNode;
    noProjectCheckbox?: ReactNode;
    tabs?: ReactNode;
    sortingMethods?: SortingTypeIndex[];
    checkbox?: boolean;
    hide?: boolean;
    fullTitle?: boolean;
    hideMainTitle?: boolean;
    children?: ReactNode;
}

export const SendProjectsEntity: FC<SendProjectsTitleProps> = ({
    count, 
    hideFilter, 
    hideCount, 
    hideSendButton = false, 
    noProjectVisible,
    chooseAllBox, 
    onMobileSortingClick, 
    sorting, 
    onSortingChange, 
    onSend, 
    isClosed, 
    children,
    tabs,
    hide = false,
    showMobileClose,
    searchData = undefined, 
    isDisabledSendButton,
    isCompetitionModal, 
    noProjectCheckbox,
    sortingMethods = undefined,
    sendText,
    titleText,
    subtitleText,
    hideMainTitle = false,
}) => {

    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const showSearch = useMemo(() => (searchData?.id), [searchData])

    const searchBar = useMemo(
        () => (
            <ProjectsSearchBar
                isLoading={false}
                sorting={sorting}
                hideRightBar={false}
                hideLeftBar={true}
                hideRightButtons
                onSortingChange={onSortingChange}
                isTagPage={false}
                projectCount={count}
                {...(!!sortingMethods ? {sortingMethods: sortingMethods} : undefined)}
            />
        ),
        [
            sorting,
            onSortingChange,
            sortingMethods,
            count
        ],
    );

    const searchInput = useMemo(() => (
        <ModalSearchWrapper>
            <MobileSearchBar placeholder={t('enter_name_or_title')} competitionId={searchData?.id} />
        </ModalSearchWrapper>
    ), [t, searchData])

    if (hide) {
        return null;
    }

    const headerCheckbox = noProjectVisible && !isClosed && noProjectCheckbox;
    const hasHeaderLeft =
        !hideMainTitle || !!subtitleText || !!headerCheckbox;
    const showActionsTitle =
        !!isClosed || hasHeaderLeft || !hideSendButton;

    return <EmployActionsModalWrapper direction="column" gy={24} zeroHeight={isClosed} fullWidth>
                {showActionsTitle && (
                <ActionsTitle 
                    justify='space-between' 
                    justifyMobile='space-between' 
                    direction='row' 
                    directionMobile="row"
                    style={{ 
                        marginBottom: (isS && noProjectCheckbox) ? 24 : 0,
                        visibility: isClosed ? 'hidden' : 'visible',
                    }} 
                >
                    <FlexBox direction="column" directionMobile="column" alignMobile="start" gy={subtitleText ? 8 : 0} style={{ gap: 8 }}>
                        {!hideMainTitle && (
                        <SendProjectsTitle mainTitle>
                            {titleText || t('competition.select_project')}
                        </SendProjectsTitle>
                        )}
                        {subtitleText && (
                            <SubtitleText>{subtitleText}</SubtitleText>
                        )}
                        {headerCheckbox} 
                    </FlexBox>
                    {!hideSendButton && (
                        <FlexBox 
                            alignMobile="flex-end" 
                            // gyMobile={showMobileClose && isMobile ? 16 : 0} 
                            direction="column"
                            widthMobile={'100%'} 
                            directionMobile="column"
                        >
                            <BrgButton 
                                variant={ButtonVariant.Filled} 
                                // width={187} 
                                fullWidth
                                disabled={isDisabledSendButton || hide} 
                                onClick={onSend}
                            >
                                {sendText || t('competition.send')}
                            </BrgButton>
                        </FlexBox>
                    )}
                </ActionsTitle>
                )}
                <FlexBox direction='row' justify='space-between' align='center'>
                {!hideCount && !tabs &&
                    <ProjectsCount>
                        {t('competition.selected_projects', {count: count})}
                    </ProjectsCount>
                }
                {!!tabs && (
                    <FlexBox direction='row' align='center' style={{ gap: 16 }}>
                        {tabs}
                    </FlexBox>
                )}
                {!hideFilter && (isMobile ? (
                    <MobileFilterSort onClick={onMobileSortingClick}>
                        <SortIcon/>
                        {t(`sorting_type.${sorting == 1 ? 'latest' : 'popular'}`)}
                    </MobileFilterSort>
                ) : searchBar)}
            </FlexBox>
            {chooseAllBox && chooseAllBox}
            {showSearch && searchInput}
        {children}
    </EmployActionsModalWrapper>
}